(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.headerBounds = { top: 0, bottom: 0 };
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header =
      document.getElementById('shopify-section-header') ||
      document.querySelector('.shopify-section-header') ||
      null;

    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection = this.header.querySelector('.header-section') || this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const prev = document.documentElement.style.getPropertyValue('--header-height');
    if (prev !== next) {
      document.documentElement.style.setProperty('--header-height', next);
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (!pastBottom) {
      if (beforeTop) {
        this._setState('reset');
      } else if (scrollTop < this.currentScrollTop) {
        this._setState('revealed');
      } else {
        this._setState('reset');
      }
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-header"]) return;
  try {
    
  class MobileStickyHeader extends HTMLElement {
    constructor() {
      super();
      this._onLayoutResize = this._onLayoutResize.bind(this);
      this._layoutResizeTimer = 0;
    }

    connectedCallback() {
      this.header =
        document.getElementById('shopify-section-mobile-header') ||
        this.closest('.shopify-section-mobile-header');
      if (!this.header) return;
      this.headerSection = this.header.querySelector('.mobile-header');
      if (!this.headerSection) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.preventHide = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this._onLayoutResize, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this._onLayoutResize);
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = 0;
    }

    _onLayoutResize() {
      if (this._layoutResizeTimer) clearTimeout(this._layoutResizeTimer);
      this._layoutResizeTimer = setTimeout(() => {
        this._layoutResizeTimer = 0;
        if (!this.header || !this.headerSection) return;
        if (!window.matchMedia('(max-width: 920px)').matches) return;
        this.createObserver();
        this.onScrollHandler();
      }, 120);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-mobile-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-mobile-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-mobile-header-hidden', 'shopify-section-mobile-header-sticky', 'animate');
    }
  }

  customElements.define('mobile-sticky-header', MobileStickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-shop"] && !Shopify.designMode) return;
  try {
    
if (!window.pbShopBound) {
 window.pbShopBound = true;
 document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-pb-shop] .pbs-pack');
  if (!button || button.disabled) return;
  const card = button.closest('[data-shop-product]');
  card.dataset.packInput = event.detail > 0 ? 'pointer' : 'keyboard';
  card.querySelectorAll('.pbs-pack').forEach(pack => pack.setAttribute('aria-pressed', String(pack === button)));
  card.querySelector('.pbs-price').textContent = button.dataset.price;
  card.querySelector('.pbs-shop-link').href = button.dataset.url;
  const subscription = button.dataset.subscription === 'true';
  card.querySelector('.pb40-price-label').textContent = subscription ? 'First subscription delivery' : 'One time purchase';
  card.querySelector('.pb40-offer-note').hidden = !subscription;
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb28-cassava"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pb28-cassava-motion')) {
  customElements.define('pb28-cassava-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.art = this.querySelector('.pb28-cm-svg');
      if (!this.art) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.sync = () => {
        const reduced = this.reduced.matches;
        this.art.classList.toggle('pb28-cm-still', reduced);
        this.art.classList.toggle('pb28-cm-paused', !this.visible || document.hidden);
      };
      this.reduced.addEventListener('change', this.sync, options);
      document.addEventListener('visibilitychange', this.sync, options);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      }, { threshold: 0.05 });
      this.observer.observe(this.art);
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.art?.classList.add('pb28-cm-paused');
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb28-compare"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pb28-formula-media')) {
  customElements.define('pb28-formula-media', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 900px), (hover: none)');
      this.ratio = 0;
      this.hovering = false;
      this.focused = false;
      this.wanted = false;
      this.update = () => {
        const shouldPlay = !this.reduced.matches && !document.hidden &&
          (this.mobile.matches ? this.ratio >= (this.wanted ? 0.15 : 0.55) : this.ratio > 0 && (this.hovering || this.focused));
        if (shouldPlay === this.wanted) return;
        this.wanted = shouldPlay;
        if (!shouldPlay) { this.stop(); return; }
        this.closest('.pb28-products').querySelectorAll('pb28-formula-media').forEach(other => { if (other !== this && other.stop) { other.wanted = false; other.stop(); } });
        const source = this.video.querySelector('source');
        if (!source.hasAttribute('src')) { source.src = source.dataset.src; this.video.load(); }
        this.video.muted = true;
        const request = this.video.play();
        if (request) request.then(() => { if (this.wanted) this.classList.add('is-playing'); else this.stop(); }).catch(() => { this.wanted = false; this.classList.remove('is-playing'); });
      };
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovering = true; this.update(); } }, opts);
      this.addEventListener('pointerleave', () => { this.hovering = false; this.update(); }, opts);
      this.addEventListener('focusin', () => { this.focused = true; this.update(); }, opts);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.update(); } }, opts);
      this.video.addEventListener('error', () => { this.wanted = false; this.stop(); }, opts);
      this.reduced.addEventListener('change', this.update, opts);
      this.mobile.addEventListener('change', this.update, opts);
      document.addEventListener('visibilitychange', this.update, opts);
      this.observer = new IntersectionObserver(entries => { this.ratio = entries[0].intersectionRatio; this.update(); }, {threshold:[0,0.15,0.55,1]});
      this.observer.observe(this);
    }
    stop() {
      this.classList.remove('is-playing');
      if (this.video) { this.video.pause(); if (this.video.readyState > 0) this.video.currentTime = 0; }
    }
    disconnectedCallback() {
      this.wanted = false;
      this.stop();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb30-signup-popup"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.pb30-signup__copy');
    if (!button) return;
    const label = button.textContent;
    const done = () => { button.textContent = button.dataset.copied; setTimeout(() => { button.textContent = label; }, 2000); };
    if (navigator.clipboard) navigator.clipboard.writeText(button.dataset.code).then(done, () => {});
    else { getSelection().selectAllChildren(button.previousElementSibling); }
  });
  if (!customElements.get('pb30-signup-focus')) {
    customElements.define('pb30-signup-focus', class extends HTMLElement {
      connectedCallback() {
        this.popup = this.closest('.pb30-signup');
        this.handleKey = this.handleKey || this.onKey.bind(this);
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.popup, { attributes: true, attributeFilter: ['class'] });
        document.addEventListener('keydown', this.handleKey);
        this.sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('keydown', this.handleKey);
      }
      sync() {
        const open = this.popup.classList.contains('open');
        if (open && !this.wasOpen) {
          this.previousFocus = document.activeElement;
          const codeMode = this.popup.classList.contains('pb30-signup--code') ? this.popup : null;
          (this.querySelector('[data-signup-result]') || codeMode || this.querySelector('.pb30-signup__close'))?.focus({ preventScroll: true });
        }
        if (!open && this.wasOpen && this.previousFocus?.isConnected && !this.contains(this.previousFocus)) {
          this.previousFocus.focus({ preventScroll: true });
        }
        this.wasOpen = open;
      }
      onKey(event) {
        if (event.key !== 'Tab' || !this.popup.classList.contains('open')) return;
        const controls = [...this.querySelectorAll('button:not([disabled]), input:not([type="hidden"]):not([disabled]), a[href]')].filter(el => el.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && (document.activeElement === first || !this.contains(document.activeElement))) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !this.contains(document.activeElement))) {
          event.preventDefault(); first?.focus();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb32-snow-first-order"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pb-order-carousel')) {
  customElements.define('pb-order-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.order-scenarios');
      this.cards = [...this.querySelectorAll('.order-scenario')];
      this.previous = this.querySelector('.order-arrow-prev');
      this.next = this.querySelector('.order-arrow-next');
      this.status = this.querySelector('.order-position');
      this.mobile = matchMedia('(max-width:760px)');
      this.index = 0;
      this.abort = new AbortController();
      const options = {signal:this.abort.signal};
      this.previous.addEventListener('click', () => this.go(-1), options);
      this.next.addEventListener('click', () => this.go(1), options);
      this.track.addEventListener('keydown', event => {
        if (!this.mobile.matches || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.go(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, {...options,passive:true});
      this.mobile.addEventListener('change', () => this.layout(), options);
      this.layout();
    }
    layout() {
      const mobile = this.mobile.matches;
      this.previous.hidden = this.next.hidden = this.status.hidden = !mobile;
      this.track.tabIndex = mobile ? 0 : -1;
      this.track.scrollTo({left:0,behavior:'instant'});
      this.index = 0;
      this.update();
    }
    go(direction) {
      const index = (this.index + direction + this.cards.length) % this.cards.length;
      this.track.scrollTo({
        left:this.cards[index].offsetLeft - this.cards[0].offsetLeft,
        behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'
      });
    }
    update() {
      const left = this.track.scrollLeft;
      this.index = this.cards.reduce((best,card,index) =>
        Math.abs(card.offsetLeft-this.cards[0].offsetLeft-left) <
        Math.abs(this.cards[best].offsetLeft-this.cards[0].offsetLeft-left) ? index : best, 0);
      this.cards.forEach((card,index) => {
        if (this.mobile.matches && index !== this.index) card.setAttribute('aria-hidden','true');
        else card.removeAttribute('aria-hidden');
      });
      const label = this.cards[this.index].querySelector('h3').textContent.trim();
      this.status.textContent = label + ' · ' + (this.index+1) + ' / ' + this.cards.length;
    }
    disconnectedCallback() {
      this.abort.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb40-compare"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('pb28-formula-media')) {
  customElements.define('pb28-formula-media', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 900px), (hover: none)');
      this.ratio = 0;
      this.hovering = false;
      this.focused = false;
      this.wanted = false;
      this.update = () => {
        const shouldPlay = !this.reduced.matches && !document.hidden &&
          (this.mobile.matches ? this.ratio >= (this.wanted ? 0.15 : 0.55) : this.ratio > 0 && (this.hovering || this.focused));
        if (shouldPlay === this.wanted) return;
        this.wanted = shouldPlay;
        if (!shouldPlay) { this.stop(); return; }
        this.closest('.pb28-products').querySelectorAll('pb28-formula-media').forEach(other => { if (other !== this && other.stop) { other.wanted = false; other.stop(); } });
        const source = this.video.querySelector('source');
        if (!source.hasAttribute('src')) { source.src = source.dataset.src; this.video.load(); }
        this.video.muted = true;
        const request = this.video.play();
        if (request) request.then(() => { if (this.wanted) this.classList.add('is-playing'); else this.stop(); }).catch(() => { this.wanted = false; this.classList.remove('is-playing'); });
      };
      this.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') { this.hovering = true; this.update(); } }, opts);
      this.addEventListener('pointerleave', () => { this.hovering = false; this.update(); }, opts);
      this.addEventListener('focusin', () => { this.focused = true; this.update(); }, opts);
      this.addEventListener('focusout', e => { if (!this.contains(e.relatedTarget)) { this.focused = false; this.update(); } }, opts);
      this.video.addEventListener('error', () => { this.wanted = false; this.stop(); }, opts);
      this.reduced.addEventListener('change', this.update, opts);
      this.mobile.addEventListener('change', this.update, opts);
      document.addEventListener('visibilitychange', this.update, opts);
      this.observer = new IntersectionObserver(entries => { this.ratio = entries[0].intersectionRatio; this.update(); }, {threshold:[0,0.15,0.55,1]});
      this.observer.observe(this);
    }
    stop() {
      this.classList.remove('is-playing');
      if (this.video) { this.video.pause(); if (this.video.readyState > 0) this.video.currentTime = 0; }
    }
    disconnectedCallback() {
      this.wanted = false;
      this.stop();
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb40-product-reviews"] && !Shopify.designMode) return;
  try {
    
// Honour a subscription selected on the shop page after Appstle initialises.
// The existing widget still owns purchase selection, price and cart submission.
if (!customElements.get('pb40-subscription-entry')) {
  customElements.define('pb40-subscription-entry', class extends HTMLElement {
    connectedCallback() {
      const plan = this.dataset.plan;
      if (!plan || this.started) return;
      this.started = true;
      let finished = false;
      let pending;
      const stop = () => {
        finished = true;
        this.observer?.disconnect();
        clearTimeout(pending);
        clearTimeout(this.deadline);
        document.removeEventListener('change', userChange, true);
      };
      const userChange = event => {
        if (event.isTrusted && event.target.closest('.appstle_sub_widget')) stop();
      };
      const apply = () => {
        if (finished) return;
        const widget = document.querySelector('.appstle_sub_widget');
        const select = widget?.querySelector('select.appstle_select');
        const radio = widget?.querySelector('input[data-appstle-real-value]');
        if (!select || !radio || !Array.from(select.options).some(option => option.value === plan)) return;
        clearTimeout(pending);
        pending = setTimeout(() => {
          if (finished || !radio.isConnected) return;
          // Disconnect before emitting events so later customer choices stay untouched.
          stop();
          if (!radio.checked) radio.click();
          if (select.value !== plan) {
            select.value = plan;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 200);
      };
      document.addEventListener('change', userChange, true);
      this.observer = new MutationObserver(apply);
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.deadline = setTimeout(stop, 15000);
      apply();
      this.cleanup = stop;
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb40-snow-reviews"] && !Shopify.designMode) return;
  try {
    
// Honour a subscription selected on the shop page after Appstle initialises.
// The existing widget still owns purchase selection, price and cart submission.
if (!customElements.get('pb40-subscription-entry')) {
  customElements.define('pb40-subscription-entry', class extends HTMLElement {
    connectedCallback() {
      const plan = this.dataset.plan;
      if (!plan || this.started) return;
      this.started = true;
      let finished = false;
      let pending;
      const stop = () => {
        finished = true;
        this.observer?.disconnect();
        clearTimeout(pending);
        clearTimeout(this.deadline);
        document.removeEventListener('change', userChange, true);
      };
      const userChange = event => {
        if (event.isTrusted && event.target.closest('.appstle_sub_widget')) stop();
      };
      const apply = () => {
        if (finished) return;
        const widget = document.querySelector('.appstle_sub_widget');
        const select = widget?.querySelector('select.appstle_select');
        const radio = widget?.querySelector('input[data-appstle-real-value]');
        if (!select || !radio || !Array.from(select.options).some(option => option.value === plan)) return;
        clearTimeout(pending);
        pending = setTimeout(() => {
          if (finished || !radio.isConnected) return;
          // Disconnect before emitting events so later customer choices stay untouched.
          stop();
          if (!radio.checked) radio.click();
          if (select.value !== plan) {
            select.value = plan;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 200);
      };
      document.addEventListener('change', userChange, true);
      this.observer = new MutationObserver(apply);
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.deadline = setTimeout(stop, 15000);
      apply();
      this.cleanup = stop;
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

if (!customElements.get('pb-terra-selected-reviews')) {
  customElements.define('pb-terra-selected-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const write = this.querySelector('[data-write-review]');
      const read = this.querySelector('[data-read-reviews]');
      const all = this.querySelector('.pb40-all-reviews');
      const nativeWrite = () => this.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
      const update = () => { write.disabled = !nativeWrite(); };
      this.observer = new MutationObserver(update);
      this.observer.observe(all, { childList: true, subtree: true });
      update();
      this.writeHandler = () => { nativeWrite()?.click(); };
      this.readHandler = () => {
        all.hidden = !all.hidden;
        read.setAttribute('aria-expanded', String(!all.hidden));
        if (!all.hidden) all.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      };
      write.addEventListener('click', this.writeHandler);
      read.addEventListener('click', this.readHandler);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('[data-write-review]')?.removeEventListener('click', this.writeHandler);
      this.querySelector('[data-read-reviews]')?.removeEventListener('click', this.readHandler);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb40-terra-reviews"] && !Shopify.designMode) return;
  try {
    
// Honour a subscription selected on the shop page after Appstle initialises.
// The existing widget still owns purchase selection, price and cart submission.
if (!customElements.get('pb40-subscription-entry')) {
  customElements.define('pb40-subscription-entry', class extends HTMLElement {
    connectedCallback() {
      const plan = this.dataset.plan;
      if (!plan || this.started) return;
      this.started = true;
      let finished = false;
      let pending;
      const stop = () => {
        finished = true;
        this.observer?.disconnect();
        clearTimeout(pending);
        clearTimeout(this.deadline);
        document.removeEventListener('change', userChange, true);
      };
      const userChange = event => {
        if (event.isTrusted && event.target.closest('.appstle_sub_widget')) stop();
      };
      const apply = () => {
        if (finished) return;
        const widget = document.querySelector('.appstle_sub_widget');
        const select = widget?.querySelector('select.appstle_select');
        const radio = widget?.querySelector('input[data-appstle-real-value]');
        if (!select || !radio || !Array.from(select.options).some(option => option.value === plan)) return;
        clearTimeout(pending);
        pending = setTimeout(() => {
          if (finished || !radio.isConnected) return;
          // Disconnect before emitting events so later customer choices stay untouched.
          stop();
          if (!radio.checked) radio.click();
          if (select.value !== plan) {
            select.value = plan;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }, 200);
      };
      document.addEventListener('change', userChange, true);
      this.observer = new MutationObserver(apply);
      this.observer.observe(document.body, { childList: true, subtree: true });
      this.deadline = setTimeout(stop, 15000);
      apply();
      this.cleanup = stop;
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

if (!customElements.get('pb-terra-selected-reviews')) {
  customElements.define('pb-terra-selected-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const write = this.querySelector('[data-write-review]');
      const read = this.querySelector('[data-read-reviews]');
      const all = this.querySelector('.pb40-all-reviews');
      const nativeWrite = () => this.querySelector('[data-testid="write-review-button"], .jdgm-write-rev-link');
      const update = () => { write.disabled = !nativeWrite(); };
      this.observer = new MutationObserver(update);
      this.observer.observe(all, { childList: true, subtree: true });
      update();
      this.writeHandler = () => { nativeWrite()?.click(); };
      this.readHandler = () => {
        all.hidden = !all.hidden;
        read.setAttribute('aria-expanded', String(!all.hidden));
        if (!all.hidden) all.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      };
      write.addEventListener('click', this.writeHandler);
      read.addEventListener('click', this.readHandler);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.querySelector('[data-write-review]')?.removeEventListener('click', this.writeHandler);
      this.querySelector('[data-read-reviews]')?.removeEventListener('click', this.readHandler);
      this.ready = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petabite-social-share"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('petabite-social-share')) {
  customElements.define('petabite-social-share', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[role=tab]')];
      this.panels = [...this.querySelectorAll('[role=tabpanel]')];
      this.messages = JSON.parse(this.querySelector('.ps-messages').textContent);
      const activate = (platform, focus = false) => {
        const current = this.panels.find(p => p.dataset.platform === platform) || this.panels[0];
        this.panels.forEach(p => p.hidden = p !== current);
        this.tabs.forEach(t => { const selected = t.dataset.platform === current.dataset.platform; t.setAttribute('aria-selected', String(selected)); t.tabIndex = selected ? 0 : -1; if (selected && focus) t.focus(); });
        this.querySelector('.ps-hero').lang = current.lang;
        for (const key of ['heading', 'intro', 'reward', 'offerOne', 'offerTwo']) this.querySelector(`[data-hero=${key}]`).textContent = new DOMParser().parseFromString(this.messages[current.dataset.platform][key], 'text/html').documentElement.textContent;
        try { sessionStorage.setItem('petabite-social-platform', current.dataset.platform); } catch (_) {}
      };
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab.dataset.platform));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = (i + 1) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); activate(this.tabs[next].dataset.platform, true); }
        });
      });
      let initial = new URLSearchParams(location.search).get('platform');
      if (!['instagram', 'rednote'].includes(initial)) { try { initial = sessionStorage.getItem('petabite-social-platform'); } catch (_) {} }
      activate(initial);
      this.querySelectorAll('[data-copy]').forEach(button => button.addEventListener('click', async () => {
        const panel = button.closest('[role=tabpanel]');
        const field = panel.querySelector(`[data-field=${button.dataset.copy}]`);
        const status = button.nextElementSibling;
        const msg = this.messages[panel.dataset.platform];
        try { await navigator.clipboard.writeText(field.value); status.textContent = msg.copied; }
        catch (_) { field.focus(); field.select(); field.setSelectionRange(0, field.value.length); status.textContent = msg.copyFailed; }
      }));
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petabite-word-search"]) return;
  try {
    
const GRID = ["LWOKRIVTIEEEWMO", "XTOBFVPARVDNYLV", "AQRQGAJUNFBDLOW", "ASPUDAPCDGGDCVR", "XHOASGVUTWUSNEM", "CIWLLTQONHLAAFT", "OEOIVXAIELCCRFG", "MLRPETABITEZEDE", "PDZLQTLUDMIVNRC", "AJFQSRUSTWPBWIJ", "NHFUULJZDQERYSM", "IQSRNHUGLWUWWFW", "ORBGUARDIANAFKB", "NFVRJWAJJLPIPIP", "WZYGRMDCARETJVS"];
const WORDS = [["PETABITE", 7, 3, 7, 10], ["COMPANION", 5, 0, 13, 0], ["GUARDIAN", 12, 3, 12, 10], ["CARE", 14, 7, 14, 10], ["LOVE", 1, 13, 4, 13], ["TRUST", 1, 1, 5, 5], ["SHIELD", 3, 1, 8, 1], ["SUSTAIN", 11, 2, 5, 8], ["PURE", 3, 6, 0, 9], ["VANGUARD", 0, 6, 7, 13], ["SAFE", 4, 11, 7, 14], ["WAIT", 11, 11, 14, 11], ["ADAPT", 4, 3, 0, 7]];
const LARGE = [[6, 7, 9], [1, 6, 7, 8, 13], [2, 5, 7, 8, 13], [1, 3, 4, 6, 9, 13], [1, 3, 4, 10, 11, 13], [0, 1, 5, 8, 11, 12], [0, 1, 7, 12, 13], [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 13, 14], [0, 1, 5], [0, 4], [0, 3], [0, 2, 11], [0, 3, 4, 5, 6, 7, 8, 9, 10, 11], [0, 11], [7, 8, 9, 10, 11]];
if (!customElements.get('petabite-word-search')) {
  class PetabiteWordSearch extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.messages = JSON.parse(this.querySelector('.pb-messages').textContent);
      this.board = this.querySelector('.pb-board');
      this.lines = this.querySelector('.pb-found-lines');
      this.active = this.querySelector('.pb-active-line');
      this.status = this.querySelector('.pb-status');
      this.counter = this.querySelector('.pb-counter');
      this.reward = this.querySelector('.pb-reward');
      this.bubble = this.querySelector('.pb-bubble');
      this.stage = this.querySelector('.pb-stage');
      this.cursor = [0, 0];
      this.found = new Set();
      this.key = 'petabite-word-search-' + this.dataset.version;
      const letters = this.querySelector('.pb-letters');
      GRID.forEach((row, r) => [...row].forEach((letter, c) => {
        const el = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        el.setAttribute('x', c * 100 + 50);
        el.setAttribute('y', r * 100 + 50);
        el.setAttribute('font-size', LARGE[r].includes(c) ? 112 : 46);
        el.textContent = letter;
        letters.append(el);
      }));
      this.wordItems = new Map();
      let art = {};
      try { art = JSON.parse(this.querySelector('.pb-art').textContent); } catch {}
      WORDS.forEach(([word]) => {
        const item = document.createElement('li');
        if (art[word]) {
          const frame = document.createElement('span'), image = new Image();
          frame.className = 'pb-word-art'; image.alt = ''; image.loading = 'lazy'; image.decoding = 'async';
          image.addEventListener('error', () => frame.remove());
          image.src = art[word]; frame.append(image); item.append(frame);
        }
        const name = document.createElement('span');
        name.textContent = word; item.append(name);
        this.querySelector('.pb-word-list').append(item);
        this.wordItems.set(word, item);
      });
      this.board.addEventListener('pointerdown', e => this.down(e));
      this.board.addEventListener('pointermove', e => this.move(e));
      this.board.addEventListener('pointerup', e => this.up(e));
      this.board.addEventListener('pointercancel', () => this.cancel());
      this.board.addEventListener('lostpointercapture', () => { if (this.pointer !== null) this.cancel(); });
      this.board.addEventListener('keydown', e => this.keyboard(e));
      this.querySelector('.pb-copy').addEventListener('click', async () => {
        const button = this.querySelector('.pb-copy');
        try {
          await navigator.clipboard.writeText(this.querySelector('.pb-code-row code').textContent);
          button.textContent = this.messages.copied;
        } catch {
          const code = this.querySelector('.pb-code-row code');
          const range = document.createRange();
          range.selectNodeContents(code);
          const selection = window.getSelection();
          selection.removeAllRanges(); selection.addRange(range);
          this.querySelector('.pb-code-note').textContent = this.messages.copyFailed;
        }
      });
      this.querySelectorAll('.pb-reset,.pb-restart').forEach(el => el.addEventListener('click', () => this.reset()));
      this.pointer = null;
      try {
        const saved = JSON.parse(localStorage.getItem(this.key) || '[]');
        if (Array.isArray(saved)) WORDS.filter(w => saved.includes(w[0])).forEach(w => this.mark(w, false));
      } catch {}
      if (this.found.size === WORDS.length) this.finish(false, true);
      this.flipIn();
    }
    flipIn() {
      // Flip board: the first time the puzzle comes into view, each letter flips over a few times through other letters and stops on its own, in a wave from the top left. PETABITE keeps flipping after the rest have settled, then lands one letter at a time, left to right.
      if (this.found.size === WORDS.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      const ABC = 'ABCDEFGHIJKLMNOPRSTUVWY', half = 140, [, brandRow, brandFrom, , brandTo] = WORDS[0];
      const run = () => {
        const texts = [...this.querySelectorAll('.pb-letters text')], real = texts.map(el => el.textContent), t0 = performance.now();
        let done = false;
        texts.forEach((el, i) => {
          const r = Math.floor(i / 15), c = i % 15, flips = 2 + (r * 7 + c * 3) % 3;
          const brand = r === brandRow && c >= brandFrom && c <= brandTo, landAt = 3400 + (c - brandFrom) * 260;
          let n = 0;
          const step = () => {
            if (done) return;
            const down = el.animate([{ transform: 'scaleY(1)' }, { transform: 'scaleY(0)' }], { duration: half, easing: 'ease-in', fill: 'forwards' });
            down.onfinish = () => {
              if (done) return;
              n++;
              const last = brand ? performance.now() - t0 >= landAt : n >= flips;
              el.textContent = last ? real[i] : ABC[Math.floor(Math.random() * ABC.length)];
              const up = el.animate([{ transform: 'scaleY(0)' }, { transform: 'scaleY(1)' }], { duration: last ? half + (brand ? 260 : 160) : half, easing: last ? 'cubic-bezier(.2,1.4,.4,1)' : 'ease-out' });
              down.cancel();
              if (!last) up.onfinish = step;
            };
          };
          setTimeout(step, (r + c) * 60 + Math.random() * 200);
        });
        // However the motion goes (a hidden tab slows it down), every letter is back in place after 7 seconds.
        setTimeout(() => { done = true; texts.forEach((el, i) => { el.getAnimations().forEach(a => a.cancel()); el.textContent = real[i]; }); }, 7000);
      };
      // Start watching only once the page has finished loading, so sections above (the homepage photo) have their full height and the flip is not spent out of sight.
      const watch = new IntersectionObserver(entries => { if (document.visibilityState === 'visible' && entries.some(e => e.isIntersecting)) { watch.disconnect(); run(); } }, { threshold: .35 });
      const start = () => watch.observe(this.board);
      if (document.readyState === 'complete') start(); else window.addEventListener('load', start, { once: true });
    }
    point(e) {
      const rect = this.board.getBoundingClientRect();
      return [Math.floor((e.clientY - rect.top) / rect.height * 15), Math.floor((e.clientX - rect.left) / rect.width * 15)];
    }
    valid(p) { return p && p.every(x => x >= 0 && x < 15); }
    snap(start, end) {
      const dr = end[0] - start[0], dc = end[1] - start[1];
      const angle = Math.round(Math.atan2(dr, dc) / (Math.PI / 4)) * Math.PI / 4;
      const r = Math.round(Math.sin(angle)), c = Math.round(Math.cos(angle));
      let length = Math.round((dr * r + dc * c) / (r * r + c * c));
      while (length > 0 && !this.valid([start[0] + r * length, start[1] + c * length])) length--;
      return [start[0] + r * length, start[1] + c * length];
    }
    line(start, end, parent) {
      const el = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      el.setAttribute('x1', start[1] * 100 + 50); el.setAttribute('y1', start[0] * 100 + 50);
      el.setAttribute('x2', end[1] * 100 + 50); el.setAttribute('y2', end[0] * 100 + 50);
      parent.append(el);
    }
    draw() {
      this.active.replaceChildren();
      if(!this.start || !this.end) return;
      this.line(this.start, this.end, this.active);
      const ring = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      ring.setAttribute('cx', this.start[1] * 100 + 50); ring.setAttribute('cy', this.start[0] * 100 + 50); ring.setAttribute('r', 44);
      this.active.append(ring);
    }
    letters(start, end) {
      const r = Math.sign(end[0] - start[0]), c = Math.sign(end[1] - start[1]);
      const length = Math.max(Math.abs(end[0] - start[0]), Math.abs(end[1] - start[1]));
      let text = '';
      for(let i = 0; i <= length; i++) text += GRID[start[0] + r * i][start[1] + c * i];
      return text;
    }
    // Exact match first. Otherwise accept an unfound word whose two ends are each within one letter of the selection.
    resolve(start, end) {
      const gap = (a, b, r, c) => Math.max(Math.abs(a - r), Math.abs(b - c));
      const exact = WORDS.find(([,a,b,x,y]) => (start[0]===a&&start[1]===b&&end[0]===x&&end[1]===y)||(start[0]===x&&start[1]===y&&end[0]===a&&end[1]===b));
      if(exact) return exact;
      if(start[0] === end[0] && start[1] === end[1]) return null;
      let best = null, bestGap = 3;
      WORDS.forEach(word => {
        const [name,a,b,x,y] = word;
        if(this.found.has(name)) return;
        [[a,b,x,y],[x,y,a,b]].forEach(([r1,c1,r2,c2]) => {
          const first = gap(start[0], start[1], r1, c1), last = gap(end[0], end[1], r2, c2);
          if(first <= 1 && last <= 1 && first + last < bestGap) { best = word; bestGap = first + last; }
        });
      });
      return best;
    }
    preview(e) {
      if(e.pointerType === 'mouse' || !this.start || !this.end) { this.bubble.hidden = true; return; }
      const match = this.resolve(this.start, this.end);
      const fresh = match && !this.found.has(match[0]);
      this.bubble.textContent = fresh ? match[0] : this.letters(this.start, this.end);
      this.bubble.classList.toggle('is-match', Boolean(fresh));
      this.bubble.hidden = false;
      const stage = this.stage.getBoundingClientRect(), width = this.bubble.offsetWidth;
      const x = Math.max(0, Math.min(stage.width - width, e.clientX - stage.left - width / 2));
      const y = Math.max(-44, e.clientY - stage.top - 84);
      this.bubble.style.transform = 'translate(' + Math.round(x) + 'px,' + Math.round(y) + 'px)';
    }
    down(e) {
      if(this.locked || this.pointer !== null || (e.pointerType === 'mouse' && e.button !== 0)) return;
      const p = this.point(e); if(!this.valid(p)) return;
      e.preventDefault(); this.pointer = e.pointerId; this.downPoint = p; this.moved = false;
      if (!this.start) this.start = p;
      this.end = this.snap(this.start, p);
      this.board.setPointerCapture(e.pointerId); this.draw(); this.preview(e);
    }
    move(e) {
      if(this.pointer !== e.pointerId) return;
      e.preventDefault(); const p = this.point(e);
      if(p[0] !== this.downPoint[0] || p[1] !== this.downPoint[1]) this.moved = true;
      this.end = this.snap(this.start, p); this.draw(); this.preview(e);
    }
    up(e) {
      if(this.pointer !== e.pointerId) return;
      e.preventDefault(); this.pointer = null; this.bubble.hidden = true;
      if(this.board.hasPointerCapture(e.pointerId)) this.board.releasePointerCapture(e.pointerId);
      const outside = !this.valid(this.point(e));
      if(outside) { this.cancel(); return; }
      if(this.start[0] === this.end[0] && this.start[1] === this.end[1] && !this.moved) {
        this.status.textContent = e.pointerType === 'mouse' ? this.messages.selected : this.messages.selectedTouch; return;
      }
      this.select();
    }
    select() {
      if(!this.start || !this.end || this.locked) return;
      const match = this.resolve(this.start, this.end);
      if(match) {
        if(this.found.has(match[0])) this.status.textContent = this.messages.duplicate;
        else { this.mark(match); this.status.textContent = match[0] + ' ' + this.messages.found + '.'; }
      } else this.status.textContent = this.messages.wrong;
      this.cancel();
      if(this.found.size === WORDS.length) this.finish();
    }
    mark(word, save=true) {
      const [name,r,c,rr,cc] = word;
      this.found.add(name); this.line([r,c],[rr,cc],this.lines);
      this.wordItems.get(name).classList.add('is-found');
      this.wordItems.get(name).setAttribute('aria-label', name + ', ' + this.messages.found);
      this.counter.textContent = this.found.size + ' / ' + WORDS.length;
      if(save) try { localStorage.setItem(this.key,JSON.stringify([...this.found])); } catch {}
    }
    cancel() { this.start = null; this.end = null; this.pointer = null; this.active.replaceChildren(); this.bubble.hidden = true; }
    keyboard(e) {
      if(this.locked) return;
      const moves = {ArrowUp:[-1,0],ArrowDown:[1,0],ArrowLeft:[0,-1],ArrowRight:[0,1]};
      if(moves[e.key]) {
        e.preventDefault(); this.cursor = this.cursor.map((v,i) => Math.max(0,Math.min(14,v+moves[e.key][i])));
        const cursor=this.querySelector('.pb-cursor');
        cursor.setAttribute('x',this.cursor[1]*100+5);cursor.setAttribute('y',this.cursor[0]*100+5);cursor.setAttribute('visibility','visible');
        this.board.setAttribute('aria-label', 'Row '+(this.cursor[0]+1)+', column '+(this.cursor[1]+1)+', '+GRID[this.cursor[0]][this.cursor[1]]);
        if(this.start){this.end=this.snap(this.start,this.cursor);this.draw();}
      } else if(e.key==='Enter'||e.key===' ') {
        e.preventDefault();
        if(this.start){this.end=this.snap(this.start,this.cursor);this.select();}
        else{this.start=[...this.cursor];this.end=[...this.cursor];this.draw();this.status.textContent=this.messages.selected;}
      } else if(e.key==='Escape'){e.preventDefault();this.cancel();}
    }
    finish(animate=true, restored=false) {
      if(this.locked || this.found.size !== WORDS.length) return;
      this.locked = true; this.cancel(); this.status.textContent=this.messages.complete;
      this.querySelector(".pb-code-row code").textContent = this.dataset.discountCode;
      this.querySelector(".pb-code-note").textContent = this.messages.code_ready;
      const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const delay=animate&&!reduced?650:0;
      this.finishTimer=setTimeout(()=>{
        this.classList.add('is-finishing');
        this.revealTimer=setTimeout(()=>{
          this.reward.hidden=false;this.classList.add('is-complete');
          if(!restored)this.querySelector('#pb-reward-title').focus({preventScroll:true});
        },animate&&!reduced?700:0);
      },delay);
    }
    reset() {
      clearTimeout(this.finishTimer);clearTimeout(this.revealTimer);this.locked=false;this.cancel();this.found.clear();
      this.lines.replaceChildren();this.classList.remove('is-complete','is-finishing');this.reward.hidden=true;
      this.wordItems.forEach((el,name)=>{el.classList.remove('is-found');el.removeAttribute('aria-label');});
      this.counter.textContent='0 / '+WORDS.length;this.status.textContent=this.messages.initial;
      this.querySelector('.pb-copy').textContent=this.messages.copy;
      try{localStorage.removeItem(this.key);}catch{}
      this.board.focus({preventScroll:true});
    }
    disconnectedCallback(){clearTimeout(this.finishTimer);clearTimeout(this.revealTimer);}
  }
  customElements.define('petabite-word-search',PetabiteWordSearch);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["secondary-header"]) return;
  try {
    
class StickySecondaryHeader extends HTMLElement {
  constructor() {
    super();

    this.header = null;
    this.headerSection = null;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.preventHide = false;
    this.isScrolling = null;
    this.predictiveSearch = null;
    this._rafScroll = 0;
    this._pendingScrollTop = 0;

    this._state = 'reset';
    this.headerBounds = { top: 0, bottom: 0 };
    this.THRESHOLD_EPS = 4;

    this._started = false;
    this.onScroll = this.onScroll.bind(this);
    this._runScroll = this._runScroll.bind(this);
    this._measure = this._measure.bind(this);
    this._start = this._start.bind(this);

    this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

    this._wakeOnScroll = this._wakeOnScroll.bind(this);
    this._wakeOnPointer = this._wakeOnPointer.bind(this);
    this._wakeOnKey = this._wakeOnKey.bind(this);
    this._onResize = this._onResize.bind(this);
    this._ensureStartedOnResize = this._ensureStartedOnResize.bind(this);
    this._resizeTimer = 0;
  }

  _getDocumentTop(el) {
    let top = 0;
    let node = el;
    while (node) {
      top += node.offsetTop || 0;
      node = node.offsetParent;
    }
    return top;
  }

  connectedCallback() {
    window.addEventListener('scroll', this._wakeOnScroll, { passive: true, once: true });
    window.addEventListener('pointerdown', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('touchstart', this._wakeOnPointer, { passive: true, once: true });
    window.addEventListener('keydown', this._wakeOnKey, { passive: true, once: true });
    window.addEventListener('resize', this._ensureStartedOnResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this._wakeOnScroll);
    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);
    window.removeEventListener('resize', this._ensureStartedOnResize);
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this._onResize);

    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

    if (this._rafScroll) cancelAnimationFrame(this._rafScroll);
    this._rafScroll = 0;
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = 0;
  }

  _onResize() {
    if (this._resizeTimer) clearTimeout(this._resizeTimer);
    this._resizeTimer = setTimeout(() => {
      this._resizeTimer = 0;
      if (!this._started || !this.header) return;
      this._measure();
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const eps = this.THRESHOLD_EPS;
      if (this.currentScrollTop <= (this.headerBounds.top + eps)) {
        this._setState('reset');
      }
      this.onScroll();
    }, 120);
  }

  _wakeOnScroll() { this._start(); }
  _wakeOnPointer() { this._start(); }
  _wakeOnKey() { this._start(); }

  _ensureStartedOnResize() {
    if (!this._started) this._start();
  }

  _start() {
    if (this._started) return;

    window.removeEventListener('pointerdown', this._wakeOnPointer);
    window.removeEventListener('touchstart', this._wakeOnPointer);
    window.removeEventListener('keydown', this._wakeOnKey);

    this.header = this.closest('.shopify-section-header');
    if (!this.header) return;

    this._started = true;

    window.removeEventListener('resize', this._ensureStartedOnResize);

    this.headerSection =
      this.header.querySelector('.secondary-header-section') ||
      this.header.querySelector('.header-section') ||
      this.header;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    this._measure();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this._onResize, { passive: true });
    this.onScroll();
  }

  _measure() {
    if (!this.header) return;

    const outerH = Math.ceil(this.header.getBoundingClientRect().height || 0);
    const innerH = this.headerSection
      ? Math.ceil(this.headerSection.getBoundingClientRect().height || 0)
      : 0;
    const h = Math.max(outerH, innerH);
    const next = `${h}px`;
    const primarySticky = document.querySelector('sticky-header');
    const skipGlobalHeaderHeight =
      primarySticky && this.header && !this.header.contains(primarySticky);
    if (!skipGlobalHeaderHeight) {
      const prev = document.documentElement.style.getPropertyValue('--header-height');
      if (prev !== next) {
        document.documentElement.style.setProperty('--header-height', next);
      }
    }

    const top = this.headerSection ? this._getDocumentTop(this.headerSection) : 0;
    this.headerBounds = { top, bottom: top + h };
  }

  onScroll() {
    this._pendingScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    if (this._rafScroll) return;
    this._rafScroll = requestAnimationFrame(this._runScroll);
  }

  _runScroll() {
    this._rafScroll = 0;

    const scrollTop = this._pendingScrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) {
      this.currentScrollTop = scrollTop;
      return;
    }

    if (window.getComputedStyle(this.header).display === 'none') {
      this.currentScrollTop = scrollTop;
      return;
    }

    const layoutRect = this.headerSection?.getBoundingClientRect();
    if (!layoutRect || layoutRect.height < 1) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const eps = this.THRESHOLD_EPS;
    let hb = this.headerBounds;
    if (!(hb.bottom > hb.top + eps)) {
      this._measure();
      hb = this.headerBounds;
    }
    if (!(hb.bottom > hb.top + eps)) {
      this.currentScrollTop = scrollTop;
      return;
    }

    const pastBottom = scrollTop > (hb.bottom + eps);
    const beforeTop  = scrollTop <= (hb.top + eps);

    if (scrollTop <= (hb.bottom + eps)) {
      this._setState('reset');
      this.currentScrollTop = scrollTop;
      return;
    }

    if (scrollTop > this.currentScrollTop && pastBottom) {
      if (!this.preventHide) this._setState('hidden');
    } else if (scrollTop < this.currentScrollTop && pastBottom) {
      if (!this.preventReveal) {
        this._setState('revealed');
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
        this._setState('hidden');
      }
    } else if (beforeTop) {
      this._setState('reset');
    }

    this.currentScrollTop = scrollTop;
  }

  _setState(next) {
    if (!this.header || this._state === next) return;
    this._state = next;

    if (next === 'hidden') {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      return;
    }

    if (next === 'revealed') {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      return;
    }

    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }
}

customElements.define('sticky-secondary-header', StickySecondaryHeader);

  } catch(e) { console.error(e); }
})();
})();
